import { useEffect, useLayoutEffect } from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { resolvePostLoginNavigateTarget } from '~/shared/utils/authReturnTo';

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  useLayoutEffect(() => {
    if (isLoading || !isAuthenticated) {
      return;
    }
    const target = resolvePostLoginNavigateTarget();
    navigate(target, { replace: true });
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <LoadingWrapper>
      <CircularProgress />
    </LoadingWrapper>
  );
};

export default LoginPage;

const LoadingWrapper = styled(Stack)({
  height: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
});
